import { Component, OnInit, ViewEncapsulation, ElementRef, Input, ViewChild, TemplateRef} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, ReactiveFormsModule} from '@angular/forms';
import { Router } from '@angular/router';
import  *  as  helpData  from  '../../../data/help/component_settings.json';
import { LocalStorage } from 'ngx-store';

//Model
import { User } from '../../../model/users.model';

//Service
import { DataService } from '../../../services/data.service';
import { ComponentsSettingsService } from '../../../services/components_settings.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-componentssettings',
  templateUrl: './componentssettings.component.html',
  styleUrls: ['./componentssettings.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ComponentsSettingsService]
})

export class ComponentsSettingsComponent implements OnInit {
	@LocalStorage() user: User;
	
	enable_all: boolean = true;
	disable_all: boolean = false;

	loadingIndicator: boolean = true;
	loadingIndicator2: boolean = false;
	spinner: boolean = false;
    help: any;
	public frm_components :FormGroup;
	frm_touched :boolean = false;

	roles:any = [];
	components:any = [];
	selected = [];
	role_active = "Super Administrator";
	role_id_active = this.svc_components_settings.sar_id;
	check_all_components: boolean = true;

	constructor(private fb : FormBuilder,
				public router: Router,
				private data: DataService,
				private svc_components_settings: ComponentsSettingsService,
				private toastr: NotificationService,
				private modal: NgbModal
    	) { 

    }

	ngOnInit(){
		this.initializeComponentData();
	}

	ngAfterViewInit() {
		setTimeout(() => { this.data.changeHelp(helpData["default"])});
	}
	
	initializeComponentData(){
		this.svc_components_settings.getTmsComponents().subscribe(data=>{
			this.roles = data['roles'];
			this.selected[0] = this.roles[0];
			this.role_active = this.roles[0].name;
			this.role_id_active = this.roles[0].id;
			this.components = data['tms_components'];

			this.initializeForm();
			this.getComponentSettings(this.role_id_active);
		})
	}

	selectRole(role){
		this.loadingIndicator2 = true;
		this.role_active = role.name;
		this.selected[0] = role;
		this.role_id_active = role.id
		this.initializeForm();
		this.getComponentSettings(this.role_id_active);
	}

	public initializeForm(){
        this.frm_components = this.fb.group({
            components: this.fb.array([
                this.initComponents(),
            ])
        });
    }

	public initComponents(){
        return this.fb.group({
			id: [''],
			component_name: [''],
            component_id:[''],
            role_id: [''],
			is_enabled: [''],	
			created_by: this.user.id
        });
    }

	public getComponentSettings(role_id) {
		this.svc_components_settings.getComponentSettings(role_id).subscribe(data => {
			this.components = data["tms_component_settings"];

			//remove dashboard
			const d_index = this.components.map(c => c.tms_components_name).indexOf('Dashboard');
			if (d_index > -1) {
				this.components.splice(d_index, 1);
			}

			var addCtrl = <FormArray> this.frm_components.controls.components;
            addCtrl.removeAt(0);
            this.components.forEach(item =>{
                let i = 0;
				addCtrl.push(this.setComponent(item));
				i=+1;
            });
			
			setTimeout(() => {this.loadingIndicator = false;}, 1000);
			setTimeout(() => { 
				this.loadingIndicator2 = false;
				this.check_all_components = true;
				this.checkSetAllComponentsValue();
			 }, 700);
		});
			
	}

	private setComponent(component) {
        return this.fb.group({
			id : [component.tms_component_settings_component_id],
			component_name: [component.tms_components_name],
            component_id: [component.tms_components_id],
            role_id: [this.role_id_active],
            created_by: [this.user.id],
			is_enabled: [component.tms_components_settings_id!=null ? 1:0],
        });
    }

	onSubmit(){
		this.spinner = true;
		let updated_data = {component_settings: this.frm_components.controls.components.value, role_id : this.role_id_active, role_name: this.svc_components_settings.access_role_name};
		this.svc_components_settings.updateComponentsSettings(updated_data).toPromise().then(data=>{
			if(data['error'] == false){
				this.toastr.showSuccess(data['message'], 'TMS Component Settings')
			}else{
				this.toastr.showError(data['message'], 'TMS Component Settings')
			};
			this.spinner = false;
			this.frm_touched = false;
			this.frm_components.markAsUntouched();
			this.frm_components.markAsPristine();			
		});
	}

	checkAllComponents(components, chk_is_components){
		if (chk_is_components.target.checked == true){
			components.map(component=> { 
				component.controls.is_enabled.setValue(true); 
				this.check_all_components = true;
			})
		}else{
			components.map(component=> { 
				component.controls.is_enabled.setValue(false); 
				this.check_all_components = false;
			})
		};
		this.frm_touched = true;
	}

	checkSetAllComponentsValue(){
		const components = this.frm_components.controls.components.value;
		
		components.map(component=>{
			if (component.is_enabled == 0) {
				this.check_all_components = false;
			};
		});
	}

	onComponentCheck(component, event){
		if (event.target.checked == true) {
			component.is_enabled.setValue(1);
		}else{
			if(this.check_all_components == true){
				this.check_all_components = false;
			};
		};
	}

}